import React, { useEffect, useRef, useState } from "react";
import CustomGrid from "../../../components/CustomComponents/CustomGrid/CustomGrid";
import { useStyles } from "../../../assets/jss/AdminUser";
import CustomBox from "../../../components/CustomComponents/CustomBox/CustomBox";
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import CustomPaper from "../../../components/CustomComponents/CustomPaper/CustomPaper";
import CustomTypography from "../../../components/CustomComponents/CustomTypography/CustomTypography";
import CustomTextField from "../../../components/CustomComponents/CustomTextField/CustomTextField";
import CustomFormControlLabel from "../../../components/CustomComponents/CustomFormControlLabel/CustomFormControlLabel";
import CustomSelect from "../../../components/CustomComponents/CustomSelect/CustomSelect";
import CustomMenuItem from "../../../components/CustomComponents/CustomMenuItem/CustomMenuItem";
import CustomInputLabel from "../../../components/CustomComponents/CustomInputLabel/CustomInputLabel";
import CustomFormControl from "../../../components/CustomComponents/CustomFormControl/CustomFormControl";
import CustomButton from "../../../components/CustomComponents/CustomButton/CustomButton";
import { useHistory } from "react-router-dom";
import backButton from "../../../assets/images/back_button.svg";
import clsx from "clsx";
import GroupHierarchy from "../../../components/GroupHierarchy/GroupHierarchy";
import {
    adminGetUser,
    adminGetUserRole,
} from "../../../services/AdminUserService";
import ErrorAlert from "../../../components/ErrorAlert/ErrorAlert";
import CustomListItem from "../../../components/CustomComponents/CustomListItem/CustomListItem";
import { CustomRadio, CustomRadioGroup } from "../../../components/CustomComponents/CustomRadio/CustomRadio";
import { CrudAction, RecordStatus, Role, RBAC_CODE, EntityAccess, GroupManageBy, WelcomeEmailType, ProviderIds } from "../../../config/app-globals.enum";
import { getSession, getUserData, getUserRBAC, } from "../../../services/LocalStorageService";
import CustomCircularProgress from "../../../components/CustomComponents/CustomCircularProgress/CustomCircularProgress";
import { useTranslation } from "react-i18next";
import { FormHelperText, useMediaQuery, useTheme } from "@material-ui/core";
// import { getCurrentGroupPreference } from "../../../services/LocalStorageService";
import DeleteGroupDialog from "../../../components/Dialogs/DeleteGroup/DeleteGroup";
import { adminGetGroup, adminGetProvider, adminUpsertGroup } from "../../../services/AdminGroupService";

export default function Group(props: any) {

    // const [groupPreference] = useState(JSON.parse(getCurrentGroupPreference()));
    const { t } = useTranslation();
    const theme = useTheme();
    const isIpadPortraitDown = useMediaQuery(theme.breakpoints.down("sm"));
    const classes = useStyles();
    // const [getRBAC_AdminGroupView] = React.useState(
    //     getUserRBAC(RBAC_CODE.ADMIN_GROUP_VIEW, props)
    // );
    const [getRBAC_AdminGroupCreateView] = React.useState(
        getUserRBAC(RBAC_CODE.ADMIN_GROUP_CREATE_VIEW, props)
    );
    const [getRBAC_AdminGroupEditView] = React.useState(
        getUserRBAC(RBAC_CODE.ADMIN_GROUP_EDIT_VIEW, props)
    );
    const [getRBAC_AdminGroupDeleteView] = React.useState(
        getUserRBAC(RBAC_CODE.ADMIN_GROUP_DELETE_VIEW, props)
    );
    const history = useHistory();
    const [loggedInUserSession] = useState(getSession);
    const [loggedInUserData] = useState(getUserData);
    const [userId, setUserId] = useState();
    const [groupId, setGroupId] = useState();
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [providerData, setProviderData] = useState(null);
    const [userData, setUserData] = useState({
        id: 0,
        firstName: "",
        middleName: "",
        lastName: "",
        userRoles: [],
        userRoleObj: [],
        email: "",
        nickName: "",
        userGroupId: "",
        isUserNameEditable: 0,
        isAnonymize: 0,
        userRoleId: 0,
        recordStatus: 0,
        status: 0,
        allowChangesToGroupOrgChart: 0,
        createdOn: "",
        providerUserInfo: {
            providerUserNo: 0,
            providerUserUid: 0
        }
    });
    const [defaultConfigData, setDefaultConfigData] = useState(null);
    const [groupData, setGroupData] = useState({
        id: "",
        name: "",
        parentGroupId: "",
        providerId: "",
        providerCode: "",
        configData: {},
        address1: "",
        address2: "",
        // status: 0,
        isWelcomeEmail: 1,      // 0-Manual; 1-Automatic
        isGroupNameEditable: 0,
        recordStatus: 0,
        createdOn: "",
        description: "",
        logoUrl: "",
        countryId: "1",
        zipCode: "",
        noOfChildGroups: "",
        allowChangesToGroupOrgChart: 1,
        noOfUsers: "",
        adminArr: [],
    });
    const [orginalGroupData, setOriginalGroupData] = useState(groupData);
    const [providerOption, setProviderOption] = useState(GroupManageBy.PRAISO) // 1:  show other provider stuff, 1: hide other provider stuff.
    const [isDriver, setIsDriver] = useState(false);
    const setFocus = useRef(true);
    const [defaultGroupFormValidation] = useState({
        name: {
            isRequired: true,
            isValid: true,
            validationMessage: "",
            pattern: "^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:.[a-zA-Z0-9-]+)*$",
        },
        providerCode: {
            isRequired: true,
            isValid: true,
            validationMessage: "",
        },
        isWelcomeEmail: {
            isRequired: false,
            isValid: true,
            validationMessage: "",
        },
    });
    const [groupFormValidation, setGroupFormValidation] = useState(defaultGroupFormValidation);
    const [groupHierarchyData, setGroupHierarchyData] = useState(null);
    const [groupHierarchyFlatData, setGroupHierarchyFlatData] = useState(null);
    // const [isUserRoleObj, setIsUserRoleObj] = useState(false);
    const [selectedGroup, setSelectedGroup] = useState(null);
    const [selectedProviderId, setSelectedProviderId] = useState(null);
    const [defaultExpandedArray, setDefaultExpandedArray] = useState([]);
    const [userViewAction, setUserViewAction] = React.useState(null);
    const [crudAction, setCrudAction] = React.useState(null);
    const [isFormValid, setIsFormValid] = React.useState(true);
    const [isFormSubmit, setIsFormSubmit] = React.useState(false);
    const [isGroupNameEdit, setIsGroupNameEdit] = useState(true);

    useEffect(() => {
        if (loggedInUserSession) {
            if (userViewAction === CrudAction.ADD) {
                setSelectedGroup(loggedInUserSession.currentGroupId);
                setUserData({
                    ...userData,
                    userGroupId: loggedInUserSession.currentGroupId,
                });
                setGroupData({
                    ...groupData,
                    parentGroupId: loggedInUserSession.currentGroupId,
                });
            }
        }
    }, [loggedInUserSession, userViewAction]);

    const [isUserRoleApiFailed, setIsUserRoleApiFailed] = useState(null);
    const [isUserRoleApi, setIsUserRoleApi] = useState(null);
    const [userRoleStatusValue, setUserRoleStatusValue] = React.useState(null);
    const [userRoleAlertMessage, setUserRoleAlertMessage] = React.useState("");
    const [isUserRoleAlertOpen, setIsUserRoleAlertOpen] = React.useState(false);
    const [defaultConfigTemplate, setDefaultConfigTemplate] = useState(null);

    const changeUserRoleApiStatusCodeFunc = (status) => {
        if (status.code && status.code !== 0 && status.code !== 200) {
            setUserRoleStatusValue(status.code);
            setUserRoleAlertMessage(
                status.message
                    ? status.message
                    : `${t("SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER")}`
            );
            setIsUserRoleAlertOpen(true);
        }
    };

    useEffect(() => {
        setUserViewAction(props.userViewAction);
        setCrudAction(props.userViewAction);
        async function getUserRoles() {
            setUserRoleStatusValue(null);
            setIsUserRoleApi(true);
            setUserRoleAlertMessage("");
            setIsUserRoleAlertOpen(false);
            const data = await adminGetUserRole();
            if (
                data &&
                (data.status.code === 0 ||
                    data.status.code === 200 ||
                    data.status.code === 201) &&
                data.content
            ) {
                setIsUserRoleApi(false);
                setIsUserRoleApiFailed(false);
                setUserRole(data.content);
            } else {
                setIsUserRoleApi(false);
                setIsUserRoleApiFailed(true);
                changeUserRoleApiStatusCodeFunc(data.status);
            }
        }
        if (!userRole) {
            getUserRoles();
        }

        if (props && props.match.params.userId && !userId) {
            setUserId(props.match.params.userId);
        }

        if (props && props.match.params.groupId && !groupId) {
            setGroupId(props.match.params.groupId);
        }

    }, [props]);


    const [isGetUserApiFailed, setIsGetUserApiFailed] = useState(null);
    const [isGetUserApi, setIsGetUserApi] = useState(null);
    const [getUserStatusValue, setGetUserStatusValue] = React.useState(null);
    const [getUserAlertMessage, setGetUserAlertMessage] = React.useState("");
    const [isGetUserAlertOpen, setIsGetUserAlertOpen] = React.useState(false);

    const changeGetGroupApiStatusCodeFunc = (status) => {
        if (status.code && status.code !== 0 && status.code !== 200) {
            setGetGroupStatusValue(status.code);
            setGetGroupAlertMessage(
                status.message
                    ? status.message
                    : `${t("SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER")}`
            );
            setIsGetGroupAlertOpen(true);
        }
    };


    const changeGetProviderApiStatusCodeFunc = (status) => {
        if (status.code && status.code !== 0 && status.code !== 200) {
            setGetGroupStatusValue(status.code);
            setGetGroupAlertMessage(
                status.message
                    ? status.message
                    : t("SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER")
            );
            setIsGetProviderAlertOpen(true);
        }
    };

    const [isGetGroupApiFailed, setIsGetGroupApiFailed] = useState(null);
    const [isGetGroupApi, setIsGetGroupApi] = useState(null);
    const [getGroupStatusValue, setGetGroupStatusValue] = React.useState(null);
    const [getGroupAlertMessage, setGetGroupAlertMessage] = React.useState("");
    const [isGetGroupAlertOpen, setIsGetGroupAlertOpen] = React.useState(false);

    const [isGetProviderApiFailed, setIsGetProviderApiFailed] = useState(null);
    const [isGetProviderApi, setIsGetProviderApi] = useState(null);
    const [getProviderStatusValue, setGetProviderStatusValue] = React.useState(null);
    const [getProviderAlertMessage, setGetProviderAlertMessage] = React.useState("");
    const [isGetProviderAlertOpen, setIsGetProviderAlertOpen] = React.useState(false);

    function dateToLocaleString(date: string) {
        var d = new Date(date);
        return d.toDateString() + ' ' + d.toLocaleTimeString();
    }

    useEffect(() => {
        async function getGroupData() {
            setGetGroupStatusValue(null);
            setIsGetGroupApi(true);
            setGetGroupAlertMessage("");
            setIsGetGroupAlertOpen(false);
            const data = await adminGetGroup(groupId);
            if (
                data &&
                (data.status.code === 0 ||
                    data.status.code === 200 ||
                    data.status.code === 201) &&
                data.content
            ) {
                setIsGetGroupApi(false);
                setIsGetGroupApiFailed(false);
                setGroupData(data.content);
                setOriginalGroupData(data.content);
                let template = {};
                if (data.content.configData) {
                    template = data.content.configData;
                }
                const keys = Object.keys(template).map(key => key);
                const vals = Object.values(template).map(value => value);
                let validationObj: any = { ...defaultGroupFormValidation };
                for (let i = 0; i < keys.length; i++) {
                    let isRequired = Boolean(vals[i]);
                    let isValid = true;
                    let validationMessage = "";
                    let name = String(keys[i]);
                    validationObj = {
                        ...validationObj,
                        [name]: {
                            isRequired,
                            isValid,
                            validationMessage
                        }
                    };
                }
                setGroupFormValidation(validationObj);
                setDefaultConfigTemplate(data.content.configData);
                setDefaultConfigData(data.content.configData);
                setSelectedProviderId(Number(data.content.providerId));
                setProviderOption(data.content.allowChangesToGroupOrgChart);
            } else {
                setIsGetGroupApi(false);
                setIsGetGroupApiFailed(true);
                changeGetGroupApiStatusCodeFunc(data.status);
                setUpsertGroupAlertMessage(
                    data.status.message
                        ? data.status.message
                        : `${t("SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER")}`
                );
                setUpsertGroupAlertType("error");
                setIsUpsertGroupAlertOpen(true);
            }
        }
        if (groupId) {
            getGroupData();
        }
    }, [groupId]);

    async function getProviderData(groupId?: any) {
        setGetProviderStatusValue(null);
        setIsGetProviderApi(true);
        setGetProviderAlertMessage("");
        setIsGetProviderAlertOpen(false);
        const data = await adminGetProvider(groupId);
        if (
            data &&
            (data.status.code === 0 ||
                data.status.code === 200 ||
                data.status.code === 201) &&
            data.content
        ) {
            setIsGetProviderApi(false);
            setIsGetProviderApiFailed(false);
            setProviderData(data.content);
            if (userViewAction === CrudAction.ADD) {
                setSelectedProviderId(-1);
            }
        } else {
            setIsGetProviderApi(false);
            setIsGetProviderApiFailed(true);
            changeGetProviderApiStatusCodeFunc(data.status);
        }
    }

    useEffect(() => {
        if (selectedProviderId !== undefined && selectedProviderId !== null && userViewAction !== CrudAction.VIEW) {
            let provider: string;
            if (selectedProviderId === ProviderIds.INHERIT && groupHierarchyFlatData) {
                const obj = groupHierarchyFlatData.find(element => element.id > selectedGroup);
                if (obj) {
                    provider = getProviderCodeFromId(Number(obj.providerId));
                    setGroupData({
                        ...groupData,
                        providerCode: provider,
                    });
                }
            }
        }
    }, [selectedProviderId]);

    const handleProviderOption = (e) => {
        setProviderOption(Number(e.target.value));
    };

    useEffect(() => {
        if (selectedGroup !== undefined && selectedGroup !== null && selectedGroup !== "") {
            getProviderData();
        }
    }, [selectedGroup]);

    useEffect(() => {
        async function getUserData() {
            setGetUserStatusValue(null);
            setIsGetUserApi(true);
            setGetUserAlertMessage("");
            setIsGetUserAlertOpen(false);
            const data = await adminGetUser(userId);
            if (
                data &&
                (data.status.code === 0 ||
                    data.status.code === 200 ||
                    data.status.code === 201) &&
                data.content
            ) {
                setIsGetUserApi(false);
                setIsGetUserApiFailed(false);
                setUserData(data.content);
                if (data.content.isUserNameEditable === 1) {
                    //setIsNameEdit(true);
                } else {
                    //setIsNameEdit(false);
                }
            } else {
                setIsGetUserApi(false);
                setIsGetUserApiFailed(true);
            }
        }
        if (userId) {
            getUserData();
        }
    }, [userId]);

    function getProviderCodeFromId(id: number, loc?: string) {
        var code = "";
        try {
            if (providerData && providerData.length > 0) {
                const provider = providerData.find(el => +el.id == id);
                if (provider) {
                    code = provider.code;
                }
            }
        } catch (error) {
            console.warn(error);
        }
        return code;
    }

    const handleProviderChange = (event) => {
        if (
            userViewAction === CrudAction.ADD ||
            userViewAction === CrudAction.EDIT
        ) {
            try {
                let tmpSelectedProviderId = Number(event.target.value);
                setSelectedProviderId(tmpSelectedProviderId);
                var code = getProviderCodeFromId(tmpSelectedProviderId);
                let validationObj: any = { ...defaultGroupFormValidation };
                if (tmpSelectedProviderId !== ProviderIds.INHERIT) {
                    var obj = providerData.find((x) => x.code === code);
                    if (obj !== undefined && obj !== null) {
                        let template = JSON.parse(obj.defaultConfigTemplate);
                        const keys = Object.keys(template).map(key => key);
                        const vals = Object.values(template).map(value => value);
                        const keysLength = keys.length;
                        if (keysLength > 0) {
                            setDefaultConfigTemplate(template);
                        } else {
                            setDefaultConfigTemplate(null);
                        }
                        for (let i = 0; i < keysLength; i++) {
                            let isRequired = Boolean(vals[i]);
                            let isValid = true;
                            let validationMessage = "";
                            let name = String(keys[i]);
                            validationObj = {
                                ...validationObj,
                                [name]: {
                                    isRequired,
                                    isValid,
                                    validationMessage
                                }
                            };
                        }
                    } else {
                        setDefaultConfigTemplate(null);
                    }
                } else {
                    setDefaultConfigTemplate(null);
                }
                setGroupFormValidation(validationObj);
                if (groupData.providerId === orginalGroupData.providerId && +groupData.providerId !== ProviderIds.INHERIT) {
                    setGroupData({
                        ...groupData,
                        configData: orginalGroupData.configData ? orginalGroupData.configData : {},
                    });
                } else {
                    setGroupData({
                        ...groupData,
                        configData: {},
                    });
                }
                setGroupData({
                    ...groupData,
                    providerCode: code,
                    providerId: "" + tmpSelectedProviderId
                });
            } catch (error) {
                console.warn(error);
            }
        }
    };

    const handleGroupChange = (event) => {
        if (
            userViewAction === CrudAction.ADD ||
            userViewAction === CrudAction.EDIT
        ) {
            const obj = groupHierarchyFlatData.find(element => element.id === String(event.target.value));
            setSelectedGroup(event.target.value);
            setUserData({ ...userData, userGroupId: event.target.value });
            setGroupData({ ...groupData, parentGroupId: obj.id, providerCode: obj.providerCode, providerId: obj.providerId, });
        }
    };
    const [userRole, setUserRole] = useState(null);

    useEffect(() => {
        if (userData && userRole && userRole.length && !userData.userRoleObj) {
            const newUserRole = [];
            for (let i = 0; i < userRole.length; i++) {
                const currentUserRole = { ...userRole[i] };
                currentUserRole.isSelected = false;
                currentUserRole.isEnabled = true;
                /** @todo: need to correct if role is enabled at admin side or not */
                if (userRole[i].name === "DRIVER") {
                    currentUserRole.isEnabled = false;
                }
                if (userData.userRoles && userData.userRoles.length) {
                    const currentUserRoleIndex = userData.userRoles.find(
                        (role) => role === userRole[i].id
                    );
                    if (currentUserRoleIndex && currentUserRoleIndex >= 0) {
                        currentUserRole.isSelected = true;
                    }
                }
                newUserRole.push(currentUserRole);
            }
            setUserData({
                ...userData,
                userRoleObj: [...newUserRole],
            });
            // setIsUserRoleObj(true);
        }
    }, [userData, userRole]);

    useEffect(() => {
        let groupArray = [];
        function insertGroupInArray(group, parentGroupId) {
            const _group = { ...group };
            _group["parentGroupId"] = parentGroupId;
            delete _group.childGroups;
            if (groupData.id !== _group.id)
                groupArray.push({ ..._group });
        }
        function insertGroup(group, parentGroupId) {
            const _group = { ...group };
            insertGroupInArray(_group, parentGroupId);
            if (_group.childGroups && _group.childGroups.length) {
                itirateGroup(_group.childGroups, _group.id);
            }
        }
        function itirateGroup(childGroups, parentGroupId) {
            if (childGroups && childGroups.length) {
                for (const group of childGroups) {
                    const _group = { ...group };
                    insertGroupInArray(_group, parentGroupId);
                    if (_group.childGroups && _group.childGroups.length) {
                        itirateGroup([..._group.childGroups], _group.id);
                    }
                }
            }
        }
        if (groupHierarchyData) {
            insertGroup(groupHierarchyData, null);
            setGroupHierarchyFlatData([...groupArray]);
        }
    }, [groupHierarchyData]);

    useEffect(() => {
        if (
            userData.userRoles &&
            userData.userRoles.length &&
            userData.userRoles.find((id) => id === Role.DRIVER)
        ) {
            setIsDriver(true);
        }
    }, [userData]);

    useEffect(() => {
        if (groupData && groupData.parentGroupId) {
            setSelectedGroup(groupData.parentGroupId);
        } else {
            setSelectedGroup(groupData.id);
        }
    }, [groupData]);

    const changeUpsertGroupApiStatusCodeFunc = (status, groupId = null) => {
        setUpsertGroupStatusValue(status.code);
        if (status.code === 0 || status.code === 200 || status.code === 201) {
            setUpsertGroupAlertMessage(status.message ? status.message : t("SUCCESS"));
            setUpsertGroupAlertType("success");
            let groupDescription = "";
            if (crudAction === CrudAction.ADD) {
                groupDescription = t("GROUP_HAS_BEEN_ADDED_SUCCESSFULLY");
            } else if (crudAction === CrudAction.EDIT) {
                groupDescription = t("GROUP_HAS_BEEN_UPDATED_SUCCESSFULLY");
            } else if (crudAction === CrudAction.DELETE) {
                groupDescription = t("GROUP_HAS_BEEN_DELETED_SUCCESSFULLY");
            }
            setUpsertGroupAlertDescription(groupDescription);
        } else {
            setUpsertGroupAlertMessage(
                status.message
                    ? status.message
                    : `${t("SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER")}`
            );
            setUpsertGroupAlertType("error");
            let groupDescription = "";
            if (crudAction === CrudAction.ADD) {
                if (status.code === 1008) {
                    groupDescription = `<Trans i18nKey="CLICK_HERE_TO_VISIT_GROUP_DETAIL">
                    Click <a href="/admin/groups/view/${groupId}">here</a> to visit user's detail
                    </Trans>`;
                } else {
                    groupDescription = t("FAILED_TO_CREATE_GROUP");
                }
            } else if (crudAction === CrudAction.EDIT) {
                groupDescription = t("FAILED_TO_UPDATE_GROUP");
            } else if (crudAction === CrudAction.DELETE) {
                groupDescription = t("FAILED_TO_DELETE_GROUP");
            }
            setUpsertGroupAlertDescription(groupDescription);
        }
        setIsUpsertGroupAlertOpen(true);
    };

    const [isUpsertGroupApiFailed, setIsUpsertGroupApiFailed] = useState(null);
    const [isUpsertGroupApi, setIsUpsertGroupApi] = useState(null);
    const [upsertGroupStatusValue, setUpsertGroupStatusValue] = React.useState(null);
    const [upsertGroupAlertMessage, setUpsertGroupAlertMessage] = React.useState("");
    const [upsertGroupAlertDescription, setUpsertGroupAlertDescription] = useState("");
    const [upsertGroupAlertType, setUpsertGroupAlertType] = useState("error");
    const [isUpsertGroupAlertOpen, setIsUpsertGroupAlertOpen] = React.useState(false);

    useEffect(() => {
        const groupRecordStatus = groupData.recordStatus;
        async function upsertGroupData(groupData) {
            const _groupDataTrimmed = { ...groupData };
            delete _groupDataTrimmed.isGroupNameEditable;
            if (userViewAction !== CrudAction.DELETE) {
                delete _groupDataTrimmed.recordStatus;
            }
            delete _groupDataTrimmed.createdOn;
            delete _groupDataTrimmed.status;
            if (userViewAction === CrudAction.ADD) {
                delete _groupDataTrimmed.id;
            }
            delete _groupDataTrimmed.adminArr;
            delete _groupDataTrimmed.noOfChildGroups;
            delete _groupDataTrimmed.noOfUsers;
            _groupDataTrimmed.allowChangesToGroupOrgChart = providerOption;
            _groupDataTrimmed.providerId = "" + selectedProviderId;
            if (selectedProviderId === -1) {
                _groupDataTrimmed.providerCode = "";
            }
            setUpsertGroupStatusValue(null);
            setIsUpsertGroupApi(true);
            setUpsertGroupAlertMessage("");
            setIsUpsertGroupAlertOpen(false);
            const data = await adminUpsertGroup(_groupDataTrimmed);
            if (
                data &&
                (data.status.code === 0 ||
                    data.status.code === 200 ||
                    data.status.code === 201) &&
                data.content
            ) {
                setIsUpsertGroupApi(false);
                setIsUpsertGroupApiFailed(false);
                changeUpsertGroupApiStatusCodeFunc(data.status);
                setIsFormSubmit(false);
                setIsFormValid(true);
                setTimeout(function () {
                    if (groupRecordStatus === RecordStatus.DELETE) {
                        history.replace(`/admin`);
                    } else {
                        history.replace(`/admin/groups/view/${data.content.id}`);
                    }
                }, 1500);
            } else if (data && data.status.code === 0) {
                changeUpsertGroupApiStatusCodeFunc(data.status);
                if (groupRecordStatus === RecordStatus.DELETE) {
                    setTimeout(function () {
                        history.replace(`/admin`);
                    }, 1500);
                }
            } else {
                setIsUpsertGroupApi(false);
                setIsUpsertGroupApiFailed(true);
                changeUpsertGroupApiStatusCodeFunc(
                    data.status,
                    data.content && data.content.id
                        ? data.content.id
                        : null
                );
                setIsFormSubmit(false);
                setIsFormValid(true);
            }
        }
        if (isFormSubmit && isFormValid) {
            upsertGroupData(groupData);
        }
    }, [isFormSubmit, isFormValid]);

    const verifyGroupInput = (userForm) => {
        setFocus.current = true;
        setIsFormSubmit(false);
        setIsFormValid(true);
        if (userForm) {
            let _groupFormValidation = { ...groupFormValidation };
            for (const [key, value] of Object.entries(groupFormValidation)) {
                const _value = { ...value };
                let currentValue = userForm[key];
                if (currentValue === undefined) {
                    currentValue = userForm.configData[key];
                }
                if (_value && _value.isRequired) {
                    if (!currentValue || !currentValue.length || currentValue === null) {
                        if (key === "providerCode") {
                            if (selectedProviderId === 0) {
                                _value.isValid = false;
                                _value.validationMessage = t("SELECT_A_PROVIDER");
                                setIsFormValid(false);
                            }
                        } else {
                            _value.isValid = false;
                            _value.validationMessage = t("THIS_FIELD_CAN_NOT_BE_EMPTY");
                            setIsFormValid(false);
                        }

                    } else {
                        _value.isValid = true;
                        _value.validationMessage = "";
                        if (key === "name") {
                            if (currentValue.trim().length < 3) {
                                _value.isValid = false;
                                _value.validationMessage = t(
                                    "GROUP_NAME_SHOULD_BE_GREATER_THAN_THREE_CHARACTERS"
                                );
                                setIsFormValid(false);
                            }
                        }
                    }
                }
                _groupFormValidation[key] = { ..._value };
            }
            setGroupFormValidation({ ..._groupFormValidation, });
            setIsFormSubmit(true);
        }
        return isFormValid;
    };

    const deleteGroupDialogFunc = (isOpen, confirmDelete) => {
        setDeleteDialogOpen(isOpen);
        if (confirmDelete) {
            setUserViewAction(CrudAction.DELETE);
            const deleteGroupObj = {
                id: groupData.id,
                recordStatus: RecordStatus.DELETE,
            };
            setCrudAction(CrudAction.DELETE);
            setGroupData({
                ...groupData,
                ...deleteGroupObj,
            });
            verifyGroupInput(groupData);
        }
    };

    const changeEmailStatus = (e) => {
        setGroupData({
            ...groupData,
            isWelcomeEmail: parseInt(e.target.value),
        });
    };

    useEffect(() => {
        const expandedNodeId = [];
        function getGroupId(groupHierarchyFlatData, selectedGroup) {
            const _group = groupHierarchyFlatData.find(
                (obj) => obj.id === selectedGroup
            );
            if (_group) {
                expandedNodeId.push(_group.id);
                if (_group.parentGroupId) {
                    getGroupId(groupHierarchyFlatData, _group.parentGroupId);
                }
            }
        }
        if (
            selectedGroup &&
            groupHierarchyFlatData &&
            groupHierarchyFlatData.length
        ) {
            getGroupId(groupHierarchyFlatData, selectedGroup);
            if (expandedNodeId && expandedNodeId.length) {
                setDefaultExpandedArray([...expandedNodeId]);
            }
        }
    }, [selectedGroup, groupHierarchyFlatData]);

    const goBackFunc = () => {
        if (
            history && ~
            history.location &&
            history.location.state &&
            history.location.state.from &&
            history.location.state.from === "/admin"
        ) {
            history.replace(`/admin`);
        } else {
            if (userViewAction === CrudAction.EDIT) {
                history.replace(`/admin/groups/view/${groupId}`, {
                    from: history.location,
                });
            } else {
                history.goBack();
            }
        }
    };

    function getDefaultConfigTempProperties(obj: any) {
        let tempProperties: { key: string, value: boolean }[] = [];
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                var obj1: any = {};
                obj1['key'] = String(key);
                obj1['value'] = Boolean(obj[key]);
            }
            tempProperties.push(obj1);
        }
        return tempProperties;
    }

    function getConfigTemplateWithoutValues(obj: any) {
        let tempProperties: { key: string, value: string }[] = [];
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                var obj1: any = {};
                obj1['key'] = String(key);
                obj1['value'] = "";
            }
            tempProperties.push(obj1);
        }
        return tempProperties;
    }

    useEffect(() => {
        if (defaultConfigData === null) {
            if (userViewAction === CrudAction.ADD) {
                const arr = getConfigTemplateWithoutValues(defaultConfigTemplate);
                var object = arr.reduce((obj, item) => Object.assign(obj, { [item.key]: item.value }), {});
                setDefaultConfigData(object);
            }
        }
    }, [defaultConfigTemplate]);

    const handleConfigDataChange = (event, index, key) => {
        if (groupData && groupData.configData) {
            var _configObj: any;
            _configObj = { ...groupData.configData };
            // for (var k in _configObj) {
            //     if (k == key) {
            _configObj[key] = event.target.value;
            // setDefaultConfigData(_configObj);
            //     }
            // }

            if (userViewAction === CrudAction.ADD) {
                setGroupData({
                    ...groupData,
                    configData: _configObj,
                });
            } else if (userViewAction === CrudAction.EDIT) {
                setGroupData({
                    ...groupData,
                    configData: { ..._configObj },
                });
            }
        }
    };

    return (
        <>
            <CustomGrid container spacing={4} justify="space-between">
                <CustomGrid item xs={12}>
                    <Breadcrumb
                        currentPage={
                            userViewAction === CrudAction.ADD
                                ? t("ADD_NEW_GROUP")
                                : userViewAction === CrudAction.EDIT
                                    ? t("EDIT_GROUP")
                                    : userViewAction === CrudAction.VIEW
                                        ? t("GROUP_DETAILS")
                                        : null
                        }
                        showAdmin
                    />
                </CustomGrid>
            </CustomGrid>
            {userViewAction !== CrudAction.ADD && isGetGroupApi ? (
                <CustomGrid
                    className={classes.userSearchResultWrapper}
                    item
                    xs={12}
                    lg={12}
                >
                    <CustomCircularProgress />
                </CustomGrid>
            ) : (
                <>
                    <CustomPaper square elevation={0} className={classes.adminPage}>
                        <CustomGrid container spacing={4} justify="space-between">
                            <CustomGrid item xs={12} className={classes.adminPageHeader}>
                                <CustomTypography
                                    component="h1"
                                    variant="h5"
                                    className={classes.adminPageTitle}
                                >
                                    <img
                                        src={backButton}
                                        onClick={goBackFunc}
                                        className={classes.goBack}
                                        alt="Back"
                                    />
                                    {userViewAction === CrudAction.ADD
                                        ? t("ADD_NEW_GROUP")
                                        : userViewAction === CrudAction.EDIT
                                            ? t("EDIT_GROUP")
                                            : userViewAction === CrudAction.VIEW
                                                ? t("GROUP_DETAILS")
                                                : null}
                                </CustomTypography>
                                {!isIpadPortraitDown &&
                                    userViewAction === CrudAction.VIEW &&
                                    getRBAC_AdminGroupEditView &&
                                    getRBAC_AdminGroupEditView.isAccessible ===
                                    EntityAccess.ALLOWED &&
                                    (getRBAC_AdminGroupEditView.isGroupScope ===
                                        EntityAccess.ALLOWED ||
                                        (loggedInUserData && loggedInUserData.id === userId)) ? (
                                    <CustomButton
                                        variant="contained"
                                        color="primary"
                                        onClick={() =>
                                            history.replace(`/admin/groups/edit/${groupId}`, {
                                                from: history.location,
                                            })
                                        }
                                        className={classes.primaryButtonXl}
                                        defaultrounded
                                    >
                                        {t("EDIT_GROUP")}
                                    </CustomButton>
                                ) : null}
                            </CustomGrid>
                            <CustomGrid item xs={12} lg={5}>
                                <CustomBox className={classes.formGroup}>
                                    <CustomTypography
                                        component="h1"
                                        variant="h5"
                                        className={classes.formGroupLabel}
                                    >
                                        {t("GROUP_INFORMATION")}
                                    </CustomTypography>
                                    <CustomTextField
                                        disabled={userViewAction === CrudAction.VIEW || !isGroupNameEdit}
                                        className={classes.adminInput}
                                        fullWidth
                                        type="text"
                                        label={`${t("GROUP_NAME")} *`}
                                        value={groupData.name}
                                        onChange={(e) =>
                                            setGroupData({
                                                ...groupData,
                                                name: e.target.value,
                                            })
                                        }
                                        InputLabelProps={{ shrink: true }}
                                        inputRef={input => {
                                            if (input && !groupFormValidation["name"].isValid && isFormSubmit && setFocus.current) {
                                                input.focus();
                                                window.scrollTo({ top: 0, behavior: 'smooth' })
                                                setFocus.current = false;
                                            }
                                        }}
                                        InputProps={{
                                            disableUnderline: true,
                                        }}
                                        error={
                                            groupFormValidation["name"].isValid ? false : true
                                        }
                                        helperText={
                                            groupFormValidation["name"].validationMessage
                                        }
                                    />
                                    <CustomFormControl
                                        disabled={
                                            userViewAction === CrudAction.VIEW ||
                                            isDriver
                                        }
                                        fullWidth
                                        className={classes.adminInput}
                                    >
                                        <CustomInputLabel
                                            className={classes.labelWithLoader}
                                            shrink
                                            id="selectGroupLabel"
                                        >
                                            {t("PARENT_GROUP")}{" *"}
                                            {!selectedGroup && !groupHierarchyFlatData && (
                                                <CustomCircularProgress
                                                    className={classes.circularProgressSmall}
                                                />
                                            )}
                                        </CustomInputLabel>
                                        {groupData.parentGroupId !== null && groupHierarchyFlatData &&
                                            groupHierarchyFlatData.length &&
                                            selectedGroup ? (
                                            <CustomSelect
                                                labelId="selectGroupLabel"
                                                disableUnderline
                                                value={selectedGroup}
                                                onChange={(e) => handleGroupChange(e)}
                                            >
                                                {groupHierarchyFlatData.map((item, index) => {
                                                    return (
                                                        <CustomMenuItem
                                                            key={`${index}-group-${item.id}`}
                                                            value={item.id}
                                                        >
                                                            {item.name}
                                                        </CustomMenuItem>
                                                    );
                                                })}
                                            </CustomSelect>
                                        ) : (groupData.parentGroupId === null) ?
                                            (<>
                                                <CustomSelect
                                                    labelId="selectGroupLabel"
                                                    value={101}
                                                    disabled={groupData.parentGroupId === null}
                                                >  {'No Parent Group'}
                                                    <CustomMenuItem
                                                        key={1}
                                                        value={101}
                                                    >
                                                        {'No Parent Group'}
                                                    </CustomMenuItem>
                                                </CustomSelect>
                                            </>) : null
                                        }
                                    </CustomFormControl>
                                </CustomBox>
                                <CustomBox className={classes.formGroup}>
                                    <CustomTypography
                                        component="h1"
                                        variant="h5"
                                        className={classes.formGroupLabel}
                                    >
                                        {t("GROUP_OR_HIERARCHY")}
                                    </CustomTypography>
                                    <CustomInputLabel
                                        style={{ marginTop: '30px' }}
                                        className={classes.labelWithLoader}
                                        shrink
                                        id="">
                                        {t("THIS_GROUP_WILL_BE_MANAGED_BY")}{""}
                                    </CustomInputLabel>

                                    <CustomRadioGroup
                                        style={{ marginTop: '30px' }}
                                        disabled={
                                            userViewAction === CrudAction.VIEW
                                            // ||
                                            // groupData.status < 0
                                        }
                                        row
                                        aria-label="providerId"
                                        name="providerId"
                                        value={
                                            providerOption
                                            // === GroupType.PRAISO ? GroupType.PRAISO : GroupType.OTHER_PROVIDER
                                        }
                                        onChange={(e) => handleProviderOption(e)}
                                    >
                                        <CustomBox
                                            flexGrow={1}
                                            className={classes.customRadioWrapper}
                                        >
                                            <CustomFormControlLabel
                                                value={GroupManageBy.TELEMATICS}
                                                control={
                                                    <CustomRadio
                                                        className={clsx(
                                                            classes.menuItemRadio,
                                                            providerOption === GroupManageBy.TELEMATICS && userViewAction !== CrudAction.VIEW
                                                                ? classes.menuItemRadioSelected
                                                                : "")}
                                                        disabled={
                                                            userViewAction === CrudAction.VIEW
                                                        }
                                                        color="primary"
                                                    />
                                                }
                                                label={t("INTEGRATIONS")}
                                            />
                                        </CustomBox>
                                        <CustomBox
                                            flexGrow={1}
                                            className={classes.customRadioWrapper}
                                        >
                                            <CustomFormControlLabel
                                                value={GroupManageBy.PRAISO}
                                                control={
                                                    <CustomRadio
                                                        className={clsx(
                                                            classes.menuItemRadio,
                                                            providerOption === GroupManageBy.PRAISO && userViewAction !== CrudAction.VIEW
                                                                ? classes.menuItemRadioSelected
                                                                : "")}
                                                        disabled={
                                                            userViewAction === CrudAction.VIEW
                                                        }
                                                        color="primary"
                                                    />
                                                }
                                                label={t("PRAISO_MANUALLY")}
                                            />
                                        </CustomBox>
                                    </CustomRadioGroup>
                                </CustomBox>
                                <CustomBox className={classes.formGroup}>
                                    <>
                                        <CustomTypography
                                            component="h1"
                                            variant="h5"
                                            className={classes.formGroupLabel}
                                        >
                                            {t("INTEGRATION")}
                                        </CustomTypography>
                                        <CustomFormControl
                                            style={{ marginTop: '30px' }}
                                            disabled={
                                                userViewAction === CrudAction.VIEW ||
                                                userData.allowChangesToGroupOrgChart === 1 ||
                                                isDriver
                                            }
                                            fullWidth
                                            className={classes.adminInput}
                                        >
                                            <CustomInputLabel
                                                className={classes.labelWithLoader}
                                                shrink
                                                id="selectGroupLabel"
                                            >
                                                {t("CHOOSE_PROVIDER")}{" "}
                                                {!providerData && (
                                                    <CustomCircularProgress
                                                        className={classes.circularProgressSmall}
                                                    />
                                                )}
                                            </CustomInputLabel>
                                            {providerData &&
                                                providerData.length && (
                                                    <>
                                                        <CustomSelect
                                                            label="selectProviderLabel"
                                                            InputLabelProps={{ shrink: true }}
                                                            inputRef={input => {
                                                                if (input && !groupFormValidation["providerCode"].isValid && isFormSubmit && setFocus.current) {
                                                                    input.focus();
                                                                    setFocus.current = false;
                                                                }
                                                            }}
                                                            disableUnderline
                                                            value={selectedProviderId}
                                                            onChange={(e) => handleProviderChange(e)}
                                                            error={
                                                                groupFormValidation["providerCode"].isValid ? false : true
                                                            }
                                                            helperText={
                                                                groupFormValidation["providerCode"].validationMessage
                                                            }
                                                        >
                                                            {providerData.map((item, index) => {
                                                                return (
                                                                    <CustomMenuItem
                                                                        key={`${index}-provider-${item.id}`}
                                                                        value={item.id}
                                                                    >
                                                                        {item.name}
                                                                    </CustomMenuItem>
                                                                );
                                                            })}
                                                        </CustomSelect>
                                                        <FormHelperText error>{(Number(selectedProviderId) === ProviderIds.INHERIT) ? groupFormValidation["providerCode"].validationMessage : null}</FormHelperText>
                                                    </>
                                                )}
                                        </CustomFormControl>
                                        <form autoComplete="new-password">
                                            {defaultConfigTemplate !== undefined && defaultConfigTemplate !== null && Number(selectedProviderId) !== ProviderIds.INHERIT ? (
                                                <CustomBox className={classes.formGroup}>
                                                    {getDefaultConfigTempProperties(defaultConfigTemplate).map((item, index) => {
                                                        return (
                                                            <CustomTextField
                                                                disabled={userViewAction === CrudAction.VIEW || !isGroupNameEdit}
                                                                className={classes.adminInput}
                                                                key={index}
                                                                fullWidth
                                                                type={item.key.toLowerCase() === "password" && item.value === true ? "password" : "text"}
                                                                label={item.value ? String(`${t(item.key)} *`).toLocaleUpperCase() : String(`${t(item.key)}`).toLocaleUpperCase()}
                                                                value={groupData.configData[item.key] ? groupData.configData[item.key] : ""}
                                                                onChange={(e) => handleConfigDataChange(e, index, item.key)}
                                                                InputLabelProps={{ shrink: true }}
                                                                InputProps={{
                                                                    disableUnderline: true,
                                                                    autoComplete: "new-password"
                                                                }}
                                                                error={
                                                                    groupFormValidation[item.key].isValid ? false : true
                                                                }
                                                                helperText={
                                                                    groupFormValidation[item.key].validationMessage
                                                                }
                                                            />
                                                        );
                                                    })}
                                                </CustomBox>
                                            )
                                                : null}
                                        </form>
                                    </>
                                    <CustomTypography
                                        style={{ marginTop: '20px' }}
                                        component="h1"
                                        variant="h5"
                                        className={classes.formGroupLabel}
                                    >
                                        {t("ADDRESS")}
                                    </CustomTypography>
                                    <CustomTextField
                                        disabled={userViewAction === CrudAction.VIEW || !isGroupNameEdit}
                                        className={classes.adminInput}
                                        fullWidth
                                        type="text"
                                        label={`${t("ADDRESS_LINE_1")} `}
                                        value={groupData.address1}
                                        onChange={(e) =>
                                            setGroupData({
                                                ...groupData,
                                                address1: e.target.value,
                                            })
                                        }
                                        InputLabelProps={{ shrink: true }}
                                        InputProps={{
                                            disableUnderline: true,
                                        }}
                                    />
                                    <CustomTextField
                                        disabled={userViewAction === CrudAction.VIEW || !isGroupNameEdit}
                                        className={classes.adminInput}
                                        fullWidth
                                        type="text"
                                        label={`${t("ADDRESS_LINE_2")} `}
                                        value={groupData.address2}
                                        onChange={(e) =>
                                            setGroupData({
                                                ...groupData,
                                                address2: e.target.value,
                                            })
                                        }
                                        InputLabelProps={{ shrink: true }}
                                        InputProps={{
                                            disableUnderline: true,
                                        }}
                                    />
                                    <CustomFormControl
                                        disabled={
                                            userViewAction === CrudAction.VIEW ||
                                            userData.allowChangesToGroupOrgChart === 1 ||
                                            isDriver
                                        }
                                        fullWidth
                                        className={classes.adminInput}
                                    >
                                        <CustomInputLabel
                                            className={classes.labelWithLoader}
                                            shrink
                                            id="selectCountryLabel"
                                        >
                                            {t("COUNTRY")}{" "}
                                            {!selectedGroup && !groupHierarchyFlatData && (
                                                <CustomCircularProgress
                                                    className={classes.circularProgressSmall}
                                                />
                                            )}
                                        </CustomInputLabel>
                                        <CustomSelect
                                            style={{ marginTop: '15px' }}
                                            labelId="selectCountryLabel"
                                            disableUnderline
                                            value={"UK"}
                                        // onChange={(e) => handleCountryChange(e)}
                                        >
                                            <CustomMenuItem
                                                key={1}
                                                value={"UK"}
                                            >
                                                {'United Kingdom'}
                                            </CustomMenuItem>
                                        </CustomSelect>
                                    </CustomFormControl>
                                    <CustomTextField
                                        disabled={userViewAction === CrudAction.VIEW || !isGroupNameEdit}
                                        className={classes.adminInput}
                                        fullWidth
                                        type="text"
                                        label={`${t("ZIPCODE")} `}
                                        value={groupData.zipCode === "0" ? "" : groupData.zipCode}
                                        onChange={(e) =>
                                            setGroupData({
                                                ...groupData,
                                                zipCode: e.target.value,
                                            })
                                        }
                                        InputLabelProps={{ shrink: true }}
                                        InputProps={{
                                            disableUnderline: true,
                                        }}
                                    />
                                </CustomBox>
                            </CustomGrid>
                            <CustomGrid item xs={12} lg={4}>
                                <CustomBox className={classes.formGroup}>
                                    <CustomTypography
                                        component="h1"
                                        variant="h5"
                                        className={classes.formGroupLabel}
                                    >
                                        {t("HIERARCHY_PREVIEW")}
                                    </CustomTypography>
                                    <CustomBox className={classes.adminPageCard}>
                                        {selectedGroup ? (
                                            <GroupHierarchy
                                                setGroupHierarchyData={(groupHierarchy) =>
                                                    setGroupHierarchyData(groupHierarchy)
                                                }
                                                selectionDisabled={
                                                    userViewAction === CrudAction.VIEW ||
                                                        userData.allowChangesToGroupOrgChart === 1 ||
                                                        isDriver
                                                        ? true
                                                        : false
                                                }
                                                defaultExpanded={[...defaultExpandedArray]}
                                                defaultSelected={selectedGroup}
                                                onHierarchySelectionChange={(e) => handleGroupChange(e)}
                                            />
                                        ) : null}
                                    </CustomBox>
                                    <CustomBox style={{ marginTop: '35px' }} className={classes.formGroup}>
                                        <CustomTypography
                                            component="h1"
                                            variant="h5"
                                            className={classes.formGroupLabel}>
                                            {t("WELCOME_EMAIL")}
                                        </CustomTypography>
                                        <CustomRadioGroup
                                            className={classes.adminPageCard}
                                            disabled={
                                                userViewAction === CrudAction.VIEW
                                                // ||
                                                // groupData.status < 0
                                            }
                                            row
                                            aria-label="IsWelcomeEmail"
                                            name="IsWelcomeEmail"
                                            value={
                                                groupData.isWelcomeEmail === WelcomeEmailType.AUTOMATIC
                                                    ? WelcomeEmailType.AUTOMATIC
                                                    : WelcomeEmailType.MANUAL
                                            }
                                            onChange={(e) => changeEmailStatus(e)}
                                        >
                                            <CustomBox
                                                flexGrow={1}
                                                className={classes.customRadioWrapper}
                                            >
                                                <CustomFormControlLabel
                                                    value={WelcomeEmailType.AUTOMATIC}
                                                    control={
                                                        <CustomRadio
                                                            className={clsx(
                                                                classes.menuItemRadio,
                                                                groupData.isWelcomeEmail === WelcomeEmailType.AUTOMATIC && userViewAction !== CrudAction.VIEW
                                                                    ? classes.menuItemRadioSelected
                                                                    : "")}
                                                            disabled={
                                                                userViewAction === CrudAction.VIEW
                                                            }
                                                            color="primary"
                                                        />
                                                    }
                                                    label={t("AUTOMATIC")}
                                                />
                                            </CustomBox>
                                            <CustomBox
                                                flexGrow={1}
                                                className={classes.customRadioWrapper}
                                            >
                                                <CustomFormControlLabel
                                                    value={WelcomeEmailType.MANUAL}
                                                    control={
                                                        <CustomRadio
                                                            className={clsx(
                                                                classes.menuItemRadio,
                                                                groupData.isWelcomeEmail === WelcomeEmailType.MANUAL && userViewAction !== CrudAction.VIEW
                                                                    ? classes.menuItemRadioSelected
                                                                    : "")}
                                                            disabled={
                                                                userViewAction === CrudAction.VIEW
                                                            }
                                                            color="primary"
                                                        />
                                                    }
                                                    label={t("MANUAL")}
                                                />
                                            </CustomBox>
                                        </CustomRadioGroup>
                                    </CustomBox>
                                    {userViewAction !== CrudAction.ADD && userData.userRoles ? (
                                        <>
                                            <CustomTypography
                                                component="h1"
                                                variant="h5"
                                                className={classes.formGroupLabel}
                                            >
                                                {t("OTHER_GROUP_INFO")}
                                            </CustomTypography>
                                            <CustomBox className={classes.adminPageCard}>
                                                {groupData ? (
                                                    <>
                                                        <CustomTypography
                                                            component="h1"
                                                            variant="h4"
                                                            className={classes.formGroupUsersLabel}
                                                        >
                                                            {t(`${groupData.noOfChildGroups} Groups and ${groupData.noOfUsers} Users inside this group `)}
                                                        </CustomTypography>
                                                        <CustomTypography
                                                            component="h1"
                                                            variant="h5"
                                                            className={classes.formInfoLabel}
                                                        >
                                                            {t("CREATED_ON")}
                                                        </CustomTypography>
                                                        <CustomTypography
                                                            component="h1"
                                                            variant="h5"
                                                            className={classes.formGroupAdminInfoLabel}
                                                        >
                                                            {dateToLocaleString(groupData.createdOn)}
                                                        </CustomTypography>
                                                        <CustomTypography
                                                            component="h1"
                                                            variant="h5"
                                                            className={classes.formInfoLabel}
                                                        >
                                                            {t("GROUP_ADMIN")}
                                                        </CustomTypography>
                                                        {groupData.adminArr && groupData.adminArr.length ?
                                                            <CustomTypography
                                                                component="h1"
                                                                variant="h5"
                                                                className={classes.formGroupAdminInfoLabel}
                                                            >
                                                                {t(`${groupData.adminArr[0]} and ${(groupData.adminArr.length) - 1} Others`)}
                                                            </CustomTypography>
                                                            :
                                                            <CustomTypography
                                                                component="h1"
                                                                variant="h5"
                                                                className={classes.formGroupAdminInfoLabel}
                                                            >
                                                                {"-"}
                                                            </CustomTypography>}
                                                    </>
                                                ) : null}
                                                {userViewAction !== CrudAction.ADD && userData.userRoles ? (
                                                    <>
                                                        <CustomListItem
                                                            className={classes.adminPageCardListitem}
                                                        >
                                                            {!isDriver && (userViewAction !== CrudAction.ADD &&
                                                                getRBAC_AdminGroupDeleteView &&
                                                                getRBAC_AdminGroupDeleteView.isGroupScope ===
                                                                EntityAccess.ALLOWED &&
                                                                getRBAC_AdminGroupDeleteView.isAccessible ===
                                                                EntityAccess.ALLOWED) ? (
                                                                <CustomButton
                                                                    disabled={isUpsertGroupApi}
                                                                    variant="outlined"
                                                                    color="secondary"
                                                                    onClick={() =>
                                                                        deleteGroupDialogFunc(true, false)
                                                                    }
                                                                    className={clsx(
                                                                        classes.deleteGroupOutlinedButton
                                                                    )}
                                                                    defaultrounded
                                                                >
                                                                    {t("DELETE_GROUP")}
                                                                    {isUpsertGroupApi &&
                                                                        crudAction === CrudAction.DELETE && (
                                                                            <>
                                                                                {" "}
                                                                                <CustomCircularProgress
                                                                                    color="secondary"
                                                                                    className={
                                                                                        classes.circularProgressSmall
                                                                                    }
                                                                                />
                                                                            </>
                                                                        )}
                                                                </CustomButton>
                                                            ) : null}
                                                        </CustomListItem>
                                                    </>
                                                ) : null}
                                            </CustomBox>
                                        </>)
                                        : null}
                                </CustomBox>
                            </CustomGrid>
                            <CustomGrid item xs={12} lg={12}>
                                {userViewAction !== CrudAction.VIEW &&
                                    ((getRBAC_AdminGroupEditView &&
                                        getRBAC_AdminGroupEditView.isAccessible ===
                                        EntityAccess.ALLOWED &&
                                        (getRBAC_AdminGroupEditView.isGroupScope ===
                                            EntityAccess.ALLOWED ||
                                            (loggedInUserData && loggedInUserData.id === userId))) ||
                                        (getRBAC_AdminGroupCreateView &&
                                            getRBAC_AdminGroupCreateView.isGroupScope ===
                                            EntityAccess.ALLOWED &&
                                            getRBAC_AdminGroupCreateView.isAccessible ===
                                            EntityAccess.ALLOWED)) ? (
                                    <CustomButton
                                        variant="contained"
                                        color="primary"
                                        disabled={isUpsertGroupApi}
                                        onClick={() => verifyGroupInput(groupData)}
                                        className={classes.primaryButtonXl}
                                        defaultrounded
                                    >
                                        {userViewAction === CrudAction.ADD
                                            ? t("ADD_GROUP")
                                            : t("UPDATE_GROUP")}
                                        {isUpsertGroupApi && crudAction !== CrudAction.DELETE && (
                                            <>
                                                {" "}
                                                <CustomCircularProgress
                                                    className={classes.circularProgressSmall}
                                                />
                                            </>
                                        )}
                                    </CustomButton>
                                ) : null}
                                {isIpadPortraitDown &&
                                    userViewAction === CrudAction.VIEW &&
                                    getRBAC_AdminGroupEditView &&
                                    getRBAC_AdminGroupEditView.isAccessible ===
                                    EntityAccess.ALLOWED &&
                                    (getRBAC_AdminGroupEditView.isGroupScope ===
                                        EntityAccess.ALLOWED ||
                                        (loggedInUserData && loggedInUserData.id === userId)) ? (
                                    <CustomButton
                                        variant="contained"
                                        color="primary"
                                        onClick={() =>
                                            history.replace(`/admin/groups/edit/${groupId}`, {
                                                from: history.location,
                                            })
                                        }
                                        href={`/admin/groups/edit/${groupId}`}
                                        className={classes.primaryButtonXl}
                                        defaultrounded
                                    >
                                        {t("EDIT_GROUP")}
                                    </CustomButton>
                                ) : null}
                            </CustomGrid>
                        </CustomGrid>
                    </CustomPaper>
                    {userViewAction !== CrudAction.DELETE && deleteDialogOpen ? (
                        <>
                            <DeleteGroupDialog
                                dialogOpen={deleteDialogOpen}
                                dialogClose={(isOpen, confirmDelete) =>
                                    deleteGroupDialogFunc(isOpen, confirmDelete)
                                }
                                groupName={groupData.name}
                            />
                        </>
                    ) : null}
                </>
            )}
            <ErrorAlert
                code={upsertGroupStatusValue}
                message={upsertGroupAlertMessage}
                description={upsertGroupAlertDescription}
                isOpen={isUpsertGroupAlertOpen}
                alertType={upsertGroupAlertType}
                isClose={(isClose) => setIsUpsertGroupAlertOpen(!isClose)}
            />
            <ErrorAlert
                code={getUserStatusValue}
                message={getUserAlertMessage}
                isOpen={isGetUserAlertOpen}
                isClose={(isClose) => setIsGetUserAlertOpen(!isClose)}
            />
            <ErrorAlert
                code={userRoleStatusValue}
                message={userRoleAlertMessage}
                isOpen={isUserRoleAlertOpen}
                isClose={(isClose) => setIsUserRoleAlertOpen(!isClose)}
            />
        </>
    );
}
